<template>
  <RequestWizardStep name="Welcome"
    :complete="requestRelatedTo === 'Medicare'"
  >
    <ContentCard
      title="Welcome!"
    >
      <AlertMessage type="info" slim>
        <p>
          This page is specifically for requesting Medicare beneficiary claims records under FOIA.
        </p>
        <p>
          If you use this secure CMS portal to electronically submit your request for Medicare
          beneficiary claims records, please do not submit the same request via alternative methods,
          such as use of our CMS FOIA email address, U.S. Postal Service, or electronic fax.
          Submitting your request(s) multiple times can delay the processing of your request.
        </p>
        <p>
          If you have already submitted a request and would like to check its progress, please
        <a href="/check-status">click here to access the CMS FOIA Status Check website</a>.
        </p>
        <p>
          If you have received a FOIA invoice, you can now pay it online through a secure website
          operated by the Department of the Treasury. Please have your invoice (CMS Form 633)
          readily available and <a target="_blank" href="https://www.pay.gov/public/form/start/1279541226"
          >click here to access Pay.Gov and pay online</a>.
        </p>
        <p>
          If you need to request other agency records from CMS under FOIA which are not
          Medicare Beneficiary claims records, <a target="_blank"
          href="https://www.foia.gov/request/agency-component/e07b59b9-db3b-4611-898d-23b42f7ead8d/"
          >click here to be redirected to the FOIA.gov portal</a>.
        </p>
      </AlertMessage>

      <p class="lead">In order to process your request as timely as possible,
        please select one of the following.</p>

      <div>
        <AlertMessage type="warning"
          :show="requestRelatedTo === 'Medicaid'"
          title="Medicaid Records"
        >
          <p>Please note that the Centers for Medicare and Medicaid Services does not hold
            any records related to Medicaid claims.</p>

          Those records are available through the Medicaid office for the state where the
          Medicaid beneficiary resides.
          <a target="_blank" href="https://medicaiddirectors.org/who-we-are/medicaid-directors/">
            Click here to access each state's Medicaid website
          </a>.
        </AlertMessage>

        <RadioButtons
          label="I am requesting claims records related to:"
          :options="['Medicare', 'Medicaid']"
          v-model="requestRelatedTo"
        />
      </div>
    </ContentCard>
  </RequestWizardStep>
</template>

<script>
import RadioButtons from '@/components/formFields/RadioButtons';
import AlertMessage from '@/components/AlertMessage';
import RequestWizardStep from '@/components/requestWizard/RequestWizardStep';

export default {
  components: {
    RadioButtons, AlertMessage, RequestWizardStep
  },

  data: () => ({
    requestRelatedTo: null
  })
};
</script>
